import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
import global from '../../../common/utility/global';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options"> 
                            <Tooltip placement="top" title="Agregar Pago">
                                <Button
                                    disabled={row.idCuentasEstado==3}
                                    type="primary"
                                    icon="plus"
                                    size={"small"}
                                    onClick={() => props.onViewPago(row)}
                                />
                            </Tooltip>
                 
                        </div>
                    )
                },
            
                {
                    title: 'Fecha Comprobante',
                    dataIndex: 'fechaStr',
                    key: 'fecha',
                    width: "120px",
                    sorter: true
                },
                {
                    title: 'Nro Comprobante',
                    dataIndex: 'serieDocumentoComprobante',
                    key: 'comprobante',
                    width: "130px",
                    sorter: true
                },
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'nombreTipoComprobante',
                    key: 'tipoComprobante',
                    width: "190px",
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimiento',
                    key: 'fechaVencimiento',
                    width: "120px",
        
                    render: (value,row) => {
                        return (<div className="custom-options" >
                            {(() => {
        
                                if(row.idCuentasEstado!=3){
                                    var valuesStart = global.fetchCurrentDateStr().split("/");
                                    var valuesEnd = value.split("/");
            
                                    // Verificamos que la fecha no sea posterior a la actual
                                    var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
                                    var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);
            
                                    if (dateStart > dateEnd) {
                                        return <Tag color={"red"}>{value}</Tag>;
            
                                    }
                                    return <Tag color={"green"}>{value}</Tag>;
                                }else{
                                    return <span>{value}</span>
                                }
                        
        
                            })()}
        
                        </div>)
                    }
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    width: "110px",
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    width: "120px",
                    sorter: true
                },
                {
                    title: 'Proveedor',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    width: "290px",
                    sorter: true
                },
                {
                    title: 'Moneda Original',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    width: "90px",
                    sorter: true
                },
        
                {
                    title: 'Total',
                    dataIndex: 'totalSoles',
                    key: 'totalSoles',
                    align: 'right',
                     render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    ) 
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    width: "90px",
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Pagado',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'canceladoSoles',
                            key: 'canceladoSoles',
                            className: 'parent-group parent-group-2',
        
                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'canceladoDolares',
                            key: 'canceladoDolares',
                            className: 'parent-group parent-group-2',
        
                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        }
                    ]
                },
        
                {
                    title: 'Por Pagar',
                    dataIndex: 'saldoSoles',
                    key: 'saldoSoles',
                    align: 'right',
                     render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    ) 
                },
                {
                    title: 'Estado',
                    dataIndex: 'idCuentasEstado',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value,row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 2: //registado
                                        return <Tag color={"red"}>{row.nombreCuentasEstado}</Tag>;
                                    case 1://ANULADA
                                        return <Tag color={"red"}>{row.nombreCuentasEstado}</Tag>;
                                    case 3://ANULADA
                                        return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;
        
                                    default:
                                        return null;
                                }
                            })()}
        
                        </div>)
                    }
                }
            ]}
        />
    );
}